// @ts-nocheck
import React, { CSSProperties } from 'react';
import css from './css';

interface Props {
  type?: string;
  last: boolean;
  role?: string;
  email?: string;
  disabled?: boolean;
  isGroupManaged?: boolean;
  label: string;
  value: string;
  selected: boolean;
  onSelect: (val: string) => void;
}

const SelectMergeTag = ({
  type,
  last,
  role,
  label,
  email,
  disabled,
  isGroupManaged,
  value,
  selected,
  onSelect,
}: Props): JSX.Element => {
  const tagSelected: CSSProperties = {
    background: '#01a6ff',
    color: '#fff',
  };

  const lastItemStyle: CSSProperties = {
    borderBottom: 'none',
  };

  const disabledStyle: CSSProperties = {
    backgroundColor: '#f1f1f1',
    cursor: 'not-allowed',
    color: '#999',
  };

  const selectedStyle = selected ? tagSelected : {};
  const lastItem = last ? lastItemStyle : {};
  const isDisabled = disabled ? disabledStyle : {};

  return (
    <button
      type="button"
      onClick={!disabled ? () => onSelect(value) : null}
      value={value}
      style={{ ...selectedStyle, ...lastItem, ...isDisabled }}
      className={customStyles.tag}
    >
      {type && type !== 'members' ? (
        <>
          {label}
          <br />
          {!!email && <div className={customStyles.memberUtility}>{email}</div>}
        </>
      ) : (
        <>
          <div className={customStyles.memberLabel}>{label}</div>
          <div className={customStyles.memberUtility}>{email}</div>
          <div className={customStyles.memberUtility}>{role}</div>
          {isGroupManaged && <div className={customStyles.memberUtility}>Access via Groups</div>}
        </>
      )}
    </button>
  );
};

const customStyles = css({
  tag: {
    width: '100%',
    display: 'block',
    textAlign: 'left',
    padding: '3px 7px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderStyle: 'none',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    transition: 'all .15s',
    lineHeight: 1.4,

    ':hover': {
      cursor: 'pointer',
      background: '#f9f9f9',
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
    },

    ':focus': {
      outline: 'none',
    },
  },
  memberLabel: {
    fontSize: 14,
  },
  memberUtility: {
    opacity: 0.5,
  },
});

export default SelectMergeTag;
